import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { influencerRepository } from '../repositories/influencer.repository';
import { mapSearchRowToInfluencer } from '../services/influencer.mappers';
import { influencerKeys } from '../services/influencer.keys';
import type { Influencer, InfluencerFilters } from '../types/influencer.types';

export interface UseInfluencersResult {
  data: Influencer[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}

export function useInfluencers(filters: InfluencerFilters = {}) {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id;

  return useQuery({
    queryKey: influencerKeys.list(orgId, filters),
    queryFn: async (): Promise<UseInfluencersResult> => {
      if (!orgId) throw new Error('No organization selected');

      const result = await influencerRepository.search(filters);
      return {
        data: result.rows.map(mapSearchRowToInfluencer),
        totalCount: result.totalCount,
        totalPages: result.totalPages,
        currentPage: result.currentPage,
        pageSize: result.pageSize,
      };
    },
    enabled: !!orgId,
  });
}
